import DescriptionIcon from "@material-ui/icons/Description";
import SubjectIcon from "@material-ui/icons/Subject";
import VisibilityIcon from "@material-ui/icons/Visibility";
import React from "react";
import {
	Button,
	Link,
	ShowButton,
	TopToolbar,
	sanitizeListRestProps,
	useListContext,
} from "react-admin";

import { EntityType } from "../../../entities";
import EditIcon from "@material-ui/icons/Edit";

const EditButton = ({ resource, record }) => {
	return (
		<Link to={`${resource}/${record.id}`}>
			<Button style={{ minWidth: "auto" }}>
				<EditIcon fontSize="inherit" />
			</Button>
		</Link>
	);
};

export const EntitiesActions = (props) => {
	const { className, exporter, filters, ...rest } = props;
	const { resource, displayedFilters, filterValues, showFilter, selectedIds, total } =
		useListContext(props);

	return React.useMemo(
		() => (
			<TopToolbar className={className} {...sanitizeListRestProps(rest)}>
				{filters &&
					React.cloneElement(filters, {
						resource,
						showFilter,
						displayedFilters,
						filterValues,
						context: "button",
					})}
			</TopToolbar>
		),
		[resource, displayedFilters, filterValues, selectedIds, filters, total] // eslint-disable-line react-hooks/exhaustive-deps
	);
};

const documentTabByEntityType = { [EntityType.task]: 2, [EntityType.order]: 3 };

export const ActionButtonsField = ({ isSearchInDocs, resource, basePath, record, ...props }) => (
	<React.Fragment>
		{record.has_documents || record.has_out_documents ? (
			<ShowButton
				label=""
				style={{ minWidth: "auto" }}
				to={`${resource}/${record.id}/show/${
					documentTabByEntityType[record.type]
				}`}	
				icon={record.has_documents ? <DescriptionIcon /> : <SubjectIcon />}
				{...props}
			/>
		) : (
			<EditButton resource={resource} record={record} />
		)}
		{isSearchInDocs && (
			<Link to={`${resource}/${record.id}/show`} target={"_blank"}>
				<Button style={{ minWidth: "auto" }}>
					<VisibilityIcon />
				</Button>
			</Link>
		)}
	</React.Fragment>
);
